var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heading-solid",
    d: "M0,33.286A1.284,1.284,0,0,1,1.286,32H5.143a1.286,1.286,0,0,1,0,2.571H4.5v4.5h9v-4.5h-.643a1.286,1.286,0,0,1,0-2.571h3.857a1.286,1.286,0,0,1,0,2.571h-.643V47.429h.643a1.286,1.286,0,0,1,0,2.571H12.857a1.286,1.286,0,1,1,0-2.571H13.5V41.643h-9v5.786h.643a1.286,1.286,0,1,1,0,2.571H1.286a1.286,1.286,0,1,1,0-2.571h.643V34.571H1.286A1.284,1.284,0,0,1,0,33.286Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingSolid);
export default __webpack_public_path__ + "static/media/heading-solid.130c8be948bb006666c6de4ad9d1ce18.svg";
export { ForwardRef as ReactComponent };